import { useGlobalState } from '../GlobalState';

function SummaryFisheryMasthead({ className = '', ...additionalProps }) {
  const [lakeInfo] = useGlobalState('lakeInfo');
  const [fisheryInfo] = useGlobalState('fisheryInfo');
  const [userSelectedLakeId] = useGlobalState('userSelectedLakeId');
  const [userSelectedLakeName] = useGlobalState('userSelectedLakeName');

  const lake = userSelectedLakeId
    ? lakeInfo?.find((lake) => lake.id === userSelectedLakeId)
    : null;

  return (
    <div
      className={'user-booking-summary__masthead ' + className}
      {...additionalProps}
      style={{
        backgroundImage: `
          linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), 
          url(${
            (userSelectedLakeId ? lake?.image : null) || fisheryInfo?.image
          })` /* Darkens image */,
        backgroundSize: 'cover',
        backgroundBlendMode: 'multiply',
        backgroundPosition: 'center',
      }}
    >
      <div
        className={
          'user-booking-summary__masthead__content pd-15 pd-top-30 gap-0 justify-end'
        }
        style={{ minHeight: '10rem' }}
      >
        {userSelectedLakeId && (
          <p className={'gRegular fs-15  white mg-bottom-0 mg-top-50'}>
            {userSelectedLakeName}
          </p>
        )}
        <h2 className={'gSemiBold fs-24 white mg-bottom-0 lh-1'}>
          {fisheryInfo?.venue_name}
        </h2>
      </div>
    </div>
  );
}

export default SummaryFisheryMasthead;
